import React, { useEffect, useState } from "react";
import JobCard from "../Jobs/JobCard";
import CandidatePageShell from "./CandidatePageShell";
import useFetch from "../../useFetch";
import { formatDate, mapApiJob } from "../../utils/jobFormatters";
import { apiRequest } from "../../utils/api";
import Pagination from "../Pagination";

const CandidateShortlistedJobs = () => {
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({});
  const [message, setMessage] = useState(false);
  const [actionError, setActionError] = useState(false);
  const apiUrl = process.env.REACT_APP_BASE_API_URL + `/candidate/saved-jobs?per_page=${perPage}&page=${page}` + (refreshKey ? `&_=${refreshKey}` : "");
  const { response, isLoading, error } = useFetch(apiUrl);

  useEffect(() => {
    setItems(response?.saved_jobs?.data ?? []);
    setMeta(response?.saved_jobs?.meta ?? {});
  }, [response]);

  const refresh = () => {
    setRefreshKey(Date.now());
  };

  const removeSavedJob = (savedJob) => {
    setActionError(false);
    setMessage(false);

    apiRequest(`/candidate/saved-jobs/${savedJob.job_id}`, {
      method: "DELETE",
    })
      .then(data => {
        setMessage(data?.message ?? "Saved job removed successfully.");
        refresh();
      })
      .catch(error => {
        setActionError(error.message || "Unable to remove saved job.");
        refresh();
      });
  };

  return (
    <CandidatePageShell
      active="shortlisted"
      title="Saved Jobs"
      text="Jobs you saved for later review."
    >
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Saved Jobs</h4>
        </div>
        <div className="widget-content">
          {message && <div className="alert alert-success"><strong>{message}</strong></div>}
          {actionError && <div className="alert alert-danger"><strong>{actionError}</strong></div>}
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}

          <div className="row">
            {!error && !isLoading && items.map((savedJob) => (
              <div className="col-lg-6 col-md-12 col-sm-12 candidate-job-card" key={savedJob.id}>
                <JobCard job={{ ...mapApiJob(savedJob.job, { time: `Saved ${formatDate(savedJob.created_at)}` }), isSaved: true }} />
                <div className="candidate-job-status">
                  <span>Saved</span>
                  <button type="button" className="candidate-link-button" onClick={() => removeSavedJob(savedJob)}>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {!error && !isLoading && items.length === 0 && (
            <div className="employee-empty-state">No saved jobs yet.</div>
          )}

          {!error && !isLoading && meta?.total > 0 && (
            <i className="d-block text-center">({meta.total} saved jobs found)</i>
          )}
          {!error && !isLoading && <Pagination meta={meta} onPageChange={setPage} label="Saved jobs pagination" />}
        </div>
      </div>
    </CandidatePageShell>
  );
};

export default CandidateShortlistedJobs;
